"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _relativeTime = _interopRequireDefault(require("dayjs/plugin/relativeTime"));

var _curry = _interopRequireDefault(require("lodash-es/curry"));

var _intl = require("@ha/intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dayjs["default"].extend(_relativeTime["default"]);

var fromNow = function fromNow(locale, isoDate) {
  if (locale === void 0) {
    locale = _intl.Locale.en;
  }

  return (0, _dayjs["default"])(isoDate, {
    locale: locale
  }).fromNow();
};

var _default = (0, _curry["default"])(fromNow, 2);

exports["default"] = _default;